import Arrow from './Arrow.tsx';
import ArrowDiagonal from './ArrowDiagonal.tsx';
import Caret from './Caret.tsx';
import Chevron from './Chevron.tsx';

export const AlignedIcons = {
  Arrow,
  ArrowDiagonal,
  Caret,
  Chevron,
};

export default AlignedIcons;
